//sidebar toc//
const h2 = document.querySelectorAll(".rte h2");
h2.forEach(function (e, index) {
  const rte = document.querySelector(".rte");
  const anchor = document.querySelector(".sidebar-sticky");
  let link = document.createElement("a");
  link.href = `#${index}`;
  link.innerHTML = `${e.textContent}`;
  anchor.appendChild(link);

  e.id = `${index}`;
  e.classList.add("anchor");
});

const sidebarSticky = document.querySelector(".sidebar-sticky");

if (sidebarSticky !== null) {
  window.addEventListener("scroll", function () {
    let scrollTop = document.documentElement.scrollTop;
    let height = sidebarSticky.offsetTop;
    console.log(height);
    if (height - 100 < scrollTop) {
      sidebarSticky.classList.add("active");
    }
  });
}

const div = document.createElement("div");
div.classList.add("container-links");
div.innerHTML = "<h4>What you'll learn:</h4>";
h2.forEach(function (e, index) {
  const flexbox = document.querySelector(".flexbox");
  const rte = document.querySelector(".rte");
  let linkt = document.createElement("a");
  linkt.href = `#${index}`;
  linkt.innerHTML = `${e.textContent}`;
  rte.insertBefore(div, flexbox);
  div.appendChild(linkt);

  e.id = `${index}`;
  e.classList.add("anchor");
});

const linkSection = document.querySelectorAll(".container-links a");

linkSection.forEach(function (e) {
  e.addEventListener("click", function () {
    linkSection.forEach(function (el) {
      el.classList.remove("active");
    });
    this.classList.add("active");
  });
});

const linksp = document.querySelectorAll(".sidebar-sticky a");

linksp.forEach(function (e) {
  e.addEventListener("click", function () {
    linksp.forEach(function (el) {
      el.classList.remove("active");
    });
    this.classList.add("active");
  });
});

let containerL = document.querySelector(".container-links a");
containerL.addEventListener("click", function () {
  anchor.classList.add("active");
});
